<template>
  <div div class="animated fadeIn">
    <b-modal ref="modalDebt" hide-footer title="REEMBOLSO VIAGEM">
     <Forms ref="frmExpense"
      :title="'CADASTRO DE DESPESAS'"
      :showHelp="false"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Despesa:</label>
          <div class="input-group">
            <b-form-select v-model="form.despesaTipoID.value" :options="form.despesaTipoID.options" @change="onChangeExpenses">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2" v-if="showAir">
        <div class="col-md-6">
          <label><small v-show="form.dataInicioVoo.required" class="text-danger">*</small> Saída:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-plane-departure"></i></span>
            <b-form-input type="date"
                          v-model="form.dataInicioVoo.value"
                          :required="form.dataInicioVoo.required"
                          :state="form.dataInicioVoo.state" />
          </div>
        </div>
        <div class="col-md-6">
          <label><small v-show="form.dataFimVoo.required" class="text-danger">*</small> Retorno:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-plane-arrival"></i></span>
            <b-form-input type="date"
                          v-model="form.dataFimVoo.value"
                          :required="form.dataFimVoo.required"
                          :state="form.dataFimVoo.state" />
          </div>
        </div>
      </div>
      <div class="form-group row pt-2" v-if="showAir">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Tipo de passagem:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-plane"></i></span>
            <b-form-select v-model="form.tipoPassagemVoo.value" :options="form.tipoPassagemVoo.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
                <option :value="1">SOMENTE IDA</option>
                <option :value="2">IDA/VOLTA</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2" v-if="showOriginDestination">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Pais / Estado / Cidade Origem:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-map-marker-alt"></i></span>
            <b-form-select v-model="form.paisOrigemID.value" :options="form.paisOrigemID.options" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryStart">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
            <b-form-select v-model="form.estadoOrigemID.value" :options="form.estadoOrigemID.options" style="max-width: 110px;margin-right: 2px" @change="onChangeStateStart">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
            <b-form-select v-model="form.cidadeOrigemID.value" :options="form.cidadeOrigemID.options" >
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-3" v-if="showOriginDestination">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Pais / Estado / Cidade Destino:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-map-marker-alt"></i></span>
            <b-form-select v-model="form.paisDestinoID.value" :options="form.paisDestinoID.options" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryEnd">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
            <b-form-select v-model="form.estadoDestinoID.value" :options="form.estadoDestinoID.options" style="max-width: 110px;margin-right: 2px" @change="onChangeStateEnd">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
            <b-form-select v-model="form.cidadeDestinoID.value" :options="form.cidadeDestinoID.options">
                <template slot="first">
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2" v-if="showKm">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Km:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-road"></i></span>
            <b-form-input type="number"
                          :placeholder="'0'"
                          v-model="form.km.value"
                          :maxlength="form.km.maxlength"
                          :required="form.km.required"
                          :state="form.km.state"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label for="txtCodePeople"><small v-show="form.dataDespesa.required" class="text-danger">*</small> Data despesa:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="far fa-calendar-alt"></i></span>
            <b-form-input type="date"
                          v-model="form.dataDespesa.value"
                          :required="form.dataDespesa.required"
                          :state="form.dataDespesa.state" />
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtGroupsName"><small class="text-danger">*</small> Quantidade:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-calculator"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="integerFormat"
                          placeholder="0"
                          v-model="form.quantidade.value"
                          :size="form.quantidade.maxlength"
                          :state="form.quantidade.state"
                          :required="form.quantidade.required"/>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label><small class="text-danger">*</small> Valor:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right"
              v-bind="moneyFormat"
              placeholder="R$ 0,00"
              prefix="R$ "
              v-model="form.valorUnitario.value"
              :size="form.valorUnitario.maxlength"
              :required="form.valorUnitario.required"
              :state="form.valorUnitario.state"/>
          </div>
        </div>
        <div class="col-md-6">
          <label><small class="text-danger">*</small> Total:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right text-bold"
              v-bind="moneyFormat"
              placeholder="R$ 0,00"
              prefix="R$ "
              v-model="Total"
              :size="form.total.maxlength"
              :required="form.total.required"
              :state="form.total.state"
              :disabled="form.total.disabled"/>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"> Observações:</label>
          <b-form-textarea
            v-model="form.observacao.value"
            :placeholder="''"
            :rows="form.observacao.rows"
            :size="form.observacao.maxlength"
            :noResize="form.observacao.noResize"></b-form-textarea>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 pt-3">
          <label><small class="text-danger">*</small> Anexar comprovante:</label>
          <div class="input-group" draggable="true" @drop="onUploadDrop" @dragover="onUploadDragover">
            <div class="upload" style="cursor: pointer;" @click="onUploadClick">
              <input
                multiple
                type="file"
                ref="inputFile"
                v-show="false"
                accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                @change="onFileChange"
              />
              <div><i class="fas fa-cloud-upload-alt" style="font-size: 17px"></i></div>
              <span v-if="!attach">Clique aqui para anexar seu comprovante</span>
              <span v-else>
                <span v-for="(upload, index) in attach" :key="index">{{ upload.name }} &nbsp;</span>
              </span>
            </div>
          </div>
        </div>
      </div>
     </Forms>
    </b-modal>
  </div>
</template>
<script>
import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import GeoMixin from '@/views/private/finance/expenses/travelrefund/mixins/GeoMixin.js'
import Tools from '@/components/tools/Tools.js'
import ExpenseItemForm from './modalDebt-form.js'
import ExpenseItemData from '@/shared/models/business/expenseitemmodel.js'
import ExpenseTyeRepository from '@/shared/http/repositories/configuration/expensetype.js'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'
import ExpenseType from '@/shared/utils/expenseType.js'

const expenses = {
  TAXI: 'TAXI',
  UBER: 'UBER',
  TAXI_UBER: 'TAXI / UBER',
  COMBUSTIVEL: 'COMBUSTÍVEL',
  PASSAGEM_AREA: 'PASSAGEM AÉREA'
}

export default {
  name: 'ExpenseTravelModalDebit',
  mixins: [ ActionsForm, GeoMixin ],
  data () {
    return {
      objSelected: null,
      data: ExpenseItemData,
      form: ExpenseItemForm,
      attach: null,
      files: [],
      showOriginDestination: false,
      showKm: false,
      showAir: false
    }
  },
  computed: {
    Total: function () {
      return this.form.quantidade.value * this.form.valorUnitario.value
    }
  },
  methods: {
    onLoad () {
      this.onLoadExpenseType()
      this.showOriginDestination = false
      this.showKm = false
      this.showAir = false
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.attach = null
      this.files = []
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
    },
    editModal (obj) {
      this.objSelected = obj.despesa
      this.$refs['modalDebt'].show()
      this.onChangeExpenses(obj.despesaTipoID)
      this.onEdit(obj)
      this.form.quantidade.value = parseInt(obj.quantidade)
      this.data = obj
      if (this.showOriginDestination) {
        this.form.paisOrigemID.value = obj.cidadeOrigem.estado.paisID
        this.form.paisDestinoID.value = obj.cidadeDestino.estado.paisID
        this.form.estadoOrigemID.value = obj.cidadeOrigem.estadoID
        this.form.estadoDestinoID.value = obj.cidadeDestino.estadoID
        this.form.cidadeOrigemID.value = obj.cidadeOrigem.id
        this.form.cidadeDestinoID.value = obj.cidadeDestino.id
      }
    },
    showModal (obj) {
      this.onClear()
      this.showOriginDestination = false
      this.showKm = false
      this.showAir = false
      this.objSelected = obj
      this.$refs['modalDebt'].show()
    },
    hideModal () {
      this.$refs['modalDebt'].hide()
    },
    onUploadClick () {
      this.$refs.inputFile.click()
    },
    onUploadDrop (event) {
      console.log('drop', event)
      event.preventDefault()
      let files = event.dataTransfer.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onUploadDragover (event) {
      event.preventDefault()
    },
    onFileChange (event) {
      event.preventDefault()
      let files = event.target.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onCreate () {
      loading.push()
      const formData = new FormData()
      this.data.despesaID = this.objSelected.id
      const json = JSON.stringify(this.data)

      if (json.hasOwnProperty('saldo')) {
        delete json['saldo']
      }

      // formData.append('file[]', this.attach)
      formData.append('data', json)
      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          formData.append('file[]', file)
        }
      } else {
        formData.append('file[]', [])
      }

      ExpenseItemRepository.Create(formData)
        .then((response) => {
          this.attach = null
          this.files = []
          this.hideModal()
          this.onResult(response)
          loading.close()
          this.$emit('Reload')
        })
        .catch(this.onException)
    },
    onUpdate () {
      this.data.status = parseInt(this.data.status)
      if (this.data.hasOwnProperty('saldo')) {
        delete this.data['saldo']
      }
      this.data.km = this.data.km ? this.data.km : 0
      ExpenseItemRepository.Update(this.data)
        .then((response) => {
          this.hideModal()
          this.onResult(response)
          loading.close()
          this.$emit('Reload')
        })
        .catch(this.onException)
    },
    onLoadExpenseType () {
      ExpenseTyeRepository.GetAllRefund()
        .then((response) => {
          var result = []
          if (response.data.code >= 0) {
            var data = response.data.data
            for (var i in data) {
              if (data[i].status) {
                if (parseInt(data[i].forma) === ExpenseType.DEBIT || parseInt(data[i].forma) === ExpenseType.DONOTCOUNT) {
                  result.push({ 'text': data[i].nome, 'value': data[i].id })
                }
              } else {
                result.push({ 'text': data[i].nome, 'value': data[i].id, disabled: true })
              }
            }
          }
          this.form.despesaTipoID.options = result
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangeExpenses (selectedValue) {
      this.showOriginDestination = false
      this.showKm = false
      this.showAir = false
      let obj = this.form.despesaTipoID.options.find(x => x.value === selectedValue)
      if (obj) {
        // Verificando tipo do lançamento para regra de campos adicionais
        let optionValue = obj.text.toUpperCase()
        if (optionValue === expenses.TAXI || optionValue === expenses.UBER || optionValue === expenses.TAXI_UBER) {
          this.showOriginDestination = true
          this.onLoadAllCountry()
          console.log(optionValue)
        } else if (optionValue === expenses.COMBUSTIVEL) {
          this.showOriginDestination = true
          this.showKm = true
          this.onLoadAllCountry()
        } else if (optionValue === expenses.PASSAGEM_AREA) {
          this.showOriginDestination = true
          this.showAir = true
          this.onLoadAllCountry()
        }
      }
    }
  }
}
</script>
<style scoped>
.upload {
  border: solid 1px #ccc;
  border-radius: 4px;
  background-color: #efefef;
  padding: 5%;
  width: 100%;
  text-align: center;
}
.upload:hover {
  border: solid 1px #008144;
}
.upload:focus {
  border: solid 1px #008144;
}

</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/details/components/modal/debt/modalDebt.vue